/* eslint-disable no-console */
import * as React from "react"; 
import { useState, useEffect } from "react";
import { jfetch, toast } from "../../utils";
import Button  from "../../components/core/Button"
import { BrowserRouter as Router, Route } from "react-router-dom";
import { useHistory, useLocation } from "react-router-dom";

function FacebookSetting(props){
  return(
    <div className="row" style={{paddingTop:'20vh'}}>
      <div className="col-md-4 offset-md-4">
        <Router>
          <Route path={"/admin/fb_settings"} exact >
            <StepOne />
          </Route>
          <Route path={"/admin/fb_settings/2"} >
            <StepTwo />
          </Route>
          <Route path={"/admin/fb_settings/3"} >
            <StepThree/>
          </Route>          
        </Router>
      </div>
    </div>
  )
}

const StepOne = (props) => {
  const history = useHistory();
  const example_token = 'EAANUZBRqcBJoBAEtKbtmoqkmPASQ1fc5HOJ3KqaT'
  const [token, setToken] = useState('');
  function next(){
    history.push('/admin/fb_settings/2', {'short_token': token})
  }
  return (
    <div className="card">
      <h4 className="card-header">FB Token</h4>
      <div className="card-body">
        <p className="card-text">Enter short-lived token from the graph explorer API.</p>
        <div className="mb-3">
          <label className="form-label">Token</label>
          <input type="text" className="form-control"  onChange={(e) => setToken(e.target.value)} value={token} placeholder={example_token} />
        </div>
        <div className="text-right">
          <Button color="primary" onClick={next}>Next</Button>
        </div>
      </div>
    </div>
  )
}

const StepTwo = (props) => {
  const [pages, setPages] = useState([]);
  const [page, setPage] = useState(null);
  const [loading, setLoading] = useState(false);
  const location = useLocation()
  const history = useHistory()
  const token = location.state.short_token
  
  useEffect(( ) => {
    get_pages();
  }, [])

  async function get_pages(){
    const resp = await fetch (`https://graph.facebook.com/v12.0/me/accounts?access_token=${token}&limit=100`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      }
    })
    const json = await resp.json();
    setPages(json.data)
  }

  function next(){
    history.push('/admin/fb_settings/3', {'page': page, 'token': token})
  }
  
  return (
    <div className="card">
    <h4 className="card-header">FB Page</h4>
      <div className="card-body">
        <p className="card-text">What Page would you like to make a token for?</p>
        <div className="mb-3">
          <label className="form-label">Page</label>
          <select value={page} onChange={(e) => setPage(e.target.value)} className="form-select">
            <option>-Choose Page-</option>
            { pages.map((page) => {
              return (
                <option key={page.id} value={page.id}>{page.name}</option>
              )
            })}
          </select>
        </div>
        <div className="text-right">
          <Button color="primary" loading={loading} onClick={next}>Next</Button>
        </div>
      </div>    
    </div>
  )
}

const StepThree = (props) => {
  const location = useLocation()
  const history = useHistory()
  const token = location.state.token
  const pageid = location.state.page
  const [pageToken, setPageToken] = useState(null);
  const [organizations, setOrganizations] = useState([]);
  const [organization, setOrganization] = useState(null);

  async function get_page_token(){
    let r1:any = await fetch(`https://graph.facebook.com/oauth/access_token?grant_type=fb_exchange_token&client_id=704903067336033&client_secret=69480911b6c85ad5204aeac3ff324de5&fb_exchange_token=${token}`)
    r1 = await r1.json();
    let long_token = r1.access_token
    let r2:any = await fetch(`https://graph.facebook.com/${pageid}?fields=access_token&access_token=${long_token}`)
    r2 = await r2.json();
    setPageToken(r2.access_token)
  }

  function get_orgs(){
    jfetch.get('/organizations/list').then((resp) => {
      setOrganizations(resp.organizations.data)
    })
  }

  function save(){
    jfetch.patch(`/organizations/${organization}/update_fb`, {
      'organization': {
        'page_id': pageid,
        'access_token': pageToken
      }
    }).then((resp) => {
      history.push('/admin/fb_settings')
    })
  }

  useEffect(()=> {
    get_page_token();
    get_orgs();
  }, [])

  return (
    <div className="card">
    <h4 className="card-header">Update FB Settings</h4>
      <div className="card-body">
        <p className="card-text">Update FB Page ID and Page Token?</p>
        <div className="mb-3">
          <label className="form-label">Page ID</label>
          <input type="text" value={pageid} className="form-control" readOnly />
        </div>
        <div className="mb-3">
          <label className="form-label">Page Token</label>
          <input type="text" value={pageToken} className="form-control" readOnly />
        </div>  
        <div className="mb-3">
          <label className="form-label">Core Organization</label>
          <select value={organization} onChange={(e) => setOrganization(e.target.value) } className="form-select">
            <option>-Choose Org-</option>
            { organizations.map((org) => {
              return (
                <option key={org.id} value={org.id}>{org.attributes.title}</option>
              )
            })}
          </select>
        </div>              
        <div className="text-right">
          <Button color="success" onClick={save}>Save</Button>
        </div>
      </div>    
    </div>
  )
}

export default FacebookSetting


// WEBPACK FOOTER //
// ./app/javascript/components/pages/FacebookSettings.tsx